import React from 'react';
import Home from './Home';

const tg = window.Telegram.WebApp;

const App = ({ isMobile }) => {
    return (
        <div id="app">
            <Home isMobile={isMobile} />
        </div>
    );
}

export default App;